import React from 'react';
import PropTypes from 'prop-types';
import skillsListInfo from './skillsListInfo.js';

function SkillsList({ className }) {
	return (
		<ul
			className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 xxl:grid-cols-8 gap-3 sm:gap-5 ${
				className || ''
			}`}
		>
			{skillsListInfo.map(({ title, imgUrl }, index) => (
				<li key={index}>
					<figure className='m-0 p-3 h-full flex flex-col items-center justify-center space-y-2 sm:p-5 text-center bg-gray-200 rounded no-underline shadow hover:shadow-xl border border-transparent border-solid  hover:border-primary-main  transition duration-300 ease-in-out  text-primary-main'>
						<img
							className='w-10 h-10 md:w-12 lg:w-14 xl:w-16'
							src={imgUrl}
							alt={`${title} icon`}
						/>
						<figcaption className='text-xs sm:text-sm md:text-base  font-normal'>
							{title}
						</figcaption>
					</figure>
				</li>
			))}
		</ul>
	);
}

export default SkillsList;

SkillsList.propTypes = {
	className: PropTypes.string,
};
